<template>
    <div class="form">
        <ValidationObserver ref="form">
            <div class="row">
                <div class="col-lg-12">
                    <p>Please mark your current availability by checking the boxes below. The more boxes you check off,
                        the greater chance that a team member will be able to find a schedule for you.</p>
                </div>
            </div>

            <AvailabilityForm
                @data-changed="updateForm"
                :user="user"
            >
            </AvailabilityForm>

            <div class="row">
                <ValidationProvider
                    name="Date"
                    rules="required"
                    v-slot="{ errors }"
                    class="col-md-6"
                >
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Date you can begin working</label>
                        <date-picker
                            style="width: 100%;"
                            value-type="format"
                            format="YYYY-MM-DD"
                            v-model="dataFormStep4.start_date"
                            @close="calcStartWorkingDate"
                        ></date-picker>
                        <FormError :error="errors[0]" name="Date"></FormError>
                    </div>
                    <div v-show="errorMessageWorkDays" class="form-group form-group-1"
                         style="font-size: 12px; color: red">The start date of the work should not be more than 30 days
                        from today's date
                    </div>
                </ValidationProvider>

            </div>
            <div class="row">
                <div class="col-12 text-right ">
                    <div class="wrap-border-top">
                        <div class="btns-wrap">
                            <a href="/application-step-3"
                               class="btn btn--outline-primary w-100 w-sm-auto">Back</a>
                            <a href="javascript:void(0)" @click="save" class="btn btn--secondary w-100 w-sm-auto">Continue</a>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>

import api from '@/js/services/api';
import AvailabilityForm from "../CommonForms/AvailabilityForm.vue";
import ApplicationFormService from "../services/ApplicationFormService";

export default {
    name: "ApplicantFormStep4",
    components: {AvailabilityForm},
    props: {
        user: {
            type: Object,
        }
    },
    data() {
        return {
            dataFormStep4: {
                start_date: null,
                night: [],
                morning: [],
                afternoon: [],
                time_absence: ''
            },
            preWorkingDays: null,
            errorMessageWorkDays: false
        }
    },

    watch: {
        preWorkingDays(newPreWorkingDays) {
            this.errorMessageWorkDays = newPreWorkingDays > 30;
        },
        start_date(newDate) {
            this.dataFormStep4 = {
                ...this.dataFormStep4,
                start_date: newDate ?? this.user.availability.start_date
            };
        }
    },

    methods: {
        calcStartWorkingDate() {
            const selectedDate = new Date(this.dataFormStep4.start_date);
            const today = new Date();
            const diff = selectedDate.getTime() - today.getTime()
            const days = (diff / 86400000).toFixed()
            this.preWorkingDays = days
        },
        save() {
            if (!Object.keys(this.dataFormStep4).length) {
                this.$showSuccessMessage();
                setTimeout(() => {
                    window.location.href = '/application-step-5';
                }, 1000)
            } else {
                (async () => {
                    const valid = await this.$refs.form.validate();

                    if (!valid) {
                        this.$showErrorMessage();
                        return;
                    }
                    try {
                        const response = await ApplicationFormService.saveStep4(this.dataFormStep4);
                        if (response.status === 200) {
                            this.$showSuccessMessage();
                            setTimeout(() => {
                                window.location.href = '/application-step-5';
                            }, 1000)
                        }
                    } catch (error) {
                        this.$handleErrors(error)
                    }
                })();
            }
        },
        updateForm(dataAvailabilityForm) {
            this.dataFormStep4 = dataAvailabilityForm;
        }
    },
    mounted() {
        if (this.user.availability) {
            this.dataFormStep4.start_date = this.user.availability.start_date
            this.dataFormStep4.morning = this.user.availability.morning
            this.dataFormStep4.afternoon = this.user.availability.afternoon
            this.dataFormStep4.night = this.user.availability.night
            this.dataFormStep4.time_absence = this.user.availability.time_absence ?? ''
        }
    }

}

</script>

<style scoped>

</style>
